import { Budget } from "../types/budget/budget";
import { api } from "./apiClient";



export class ServicesService {


  static async getService(projectId: string): Promise<any> {
    return api.get("/pre-budget/get?", {
      params: {
        project: projectId,
      },
    })
    .then((response) => response.data);
  }

  static async update(id: string, budgetData: any): Promise<any> {
    const {
      type: _legacyType,
      __v: _version,
      isApiUpdate: _isApiUpdate,
      ...safeBudgetData
    } = budgetData || {};

    return api
      .put(`/pre-budget/update/${id}`, safeBudgetData)
      .then((response) => response.data);
  }
  static async create(data: Budget): Promise<any> {
    return api.post("/pre-budget/create", data).then((response) => response.data);
  }


}
